
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {fetchOptionListData, updateOptionListData} from "../../../slices/LocationSlice/optionSlice";
import Pagination from "../../../components/Pagination";
import Loader from "../../../components/Loader";
import EditableTable from "./OptionTable";
import Modal from "../../../components/Modal"
import ChangeLog from "../../../components/ChangeLog";




function Option({editable}) {

  const dispatch = useDispatch();
  const { optionList, status } = useSelector((state) => state.option);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(optionList?.result) ? optionList?.result?.slice(indexOfFirstItem, indexOfLastItem) : [];
  const totalPages = Array.isArray(optionList?.result) ? Math.ceil(optionList?.result?.length / itemsPerPage) : 0;
  const headers = optionList?.result?.length > 0 ? Object.keys(optionList.result[0]).filter((key) => key !== 'id') : [];
  const editableFields = ['title','status','code','val','optionType']; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog,setCurrentLog] = useState([]);


  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    if(status==="idle"){
      dispatch(fetchOptionListData());
    }

  }, [dispatch]);



  if (status === "loading") {
    return <Loader></Loader>;
  }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = optionList.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };


  const handleSave = async () => {
    const { id, title} = editedData;
    const resp = await dispatch(updateOptionListData({id,title}));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchOptionListData());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field,val) => {
      if(['status','active'].includes(field)){
        setEditedData((prev) => ({
          ...prev,
          [field]:!val,
        }));
      }else{
        setEditedData((prev) => ({
          ...prev,
          [field]:e.target.value,
        }));
      }
  };

  const handleLog = (id)=>{
    const logData = optionList.Change_Log.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  return (
    <div className="w-full flex items-center flex-col max-w-full">
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
        editable={editable}
      />
      
      <div className="flex mt-4 items-center justify-between w-11/12">

      {/* <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      /> */}


    </div>
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />
    </div>
  );
}

export default Option;